import { render, staticRenderFns } from "./MandatsByUser.vue?vue&type=template&id=450e62b7&"
import script from "./MandatsByUser.vue?vue&type=script&lang=js&"
export * from "./MandatsByUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports